import { render, staticRenderFns } from "./Bootstrap.vue?vue&type=template&id=288be1be&scoped=true&"
import script from "./Bootstrap.vue?vue&type=script&lang=js&"
export * from "./Bootstrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288be1be",
  null
  
)

export default component.exports